import React, { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Loading } from '../Components/Common'

// Internal Routes
const BOE = lazy(() => import('../Components/BOE'))
const COF = lazy(() => import('../Components/COF'))
const MX = lazy(() => import('../Components/MX'))
// const QuoteRequest = lazy(() =>
//   import('../Components/QuoteRequest/QuoteRequest')
// )
const MainMenu = lazy(() => import('../Components/MainMenu'))

const Routs = () => (
  <Suspense fallback={<Loading />}>
    <Routes>
      <Route exact path="/" element={<MainMenu/>} />
      <Route exact path="/BOE" element={<BOE/>} />
      <Route exact path="/COF" element={<COF/>} />
      <Route exact path="/MX" element={<MX/>} />
      {/* <Route exact path="/quotes" element={<QuoteRequest/>} /> */}
    </Routes>
  </Suspense>
)

export default Routs
